export const validationRules = {
  required: (label) => (v) => !!v || `${label} is required`,
  minLength: (label, min) => (v) =>
    !v || v.length >= min || `${label} must be at least ${min} characters`,
  maxLength: (label, max) => (v) =>
    !v || v.length <= max || `${label} cannot be more than ${max} characters`,
  email: (v) =>
    (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) && v.length <= 254) ||
    'E-mail must be valid and cannot be more than 254 characters (e.g.: name@example.com)',
  pattern: (label, regex, msg) => (v) => !v || regex.test(v) || msg,
  oneOf: (label, values) => (v) =>
    !v || values.includes(v) || `${label} must be one of ${values.join(', ')}`,
  restrictSpecialChars: (label) => (v) =>
    !/[&<>]/.test(v) || `${label} cannot contain special characters such as &, < or >`
};
